module.exports = __webpack_public_path__ + "img/noise_test.c147eb22.jpg";